module.exports = __webpack_public_path__ + "static/media/leave-room-icon.e8cc2c1f.svg";